export const ProductActionTypes = {
  SET_PRODUCT_LIST: "@@product/SET_PRODUCT_LIST",
  SET_SELECTED_PRODUCT: "@@product/SET_SELECTED_PRODUCT",
  SET_SELECTED_PRODUCT_BY_CATEGORY:
    "@@product/SET_SELECTED_PRODUCT_BY_CATEGORY",
};
